const DITypes = {
  JsonRpcDispatcher: Symbol('InvestorTargetingJsonRpcDispatcher'),
  DispatcherFactory: Symbol('InvestorTargetingDispatcherFactory'),
  AdapterFactory: Symbol('InvestorTargetingAdapterFactory'),
};

export default DITypes;
